import type { CSSProperties } from 'react';
export type Gradient = 'red' | 'green' | 'blue' | 'purple' | 'orange' | 'pink';

const gradient = (color?: Gradient, type: 'background' | 'text' = 'background') => {
    if (!color) {
        return {};
    }

    const gradients: {
        [key in Gradient]: string;
    } = {
        red: 'linear-gradient(45deg, var(--mantine-color-gray-8), var(--mantine-color-dark-6))',
        green: 'linear-gradient(45deg, var(--mantine-color-gray-7), var(--mantine-color-dark-5))',
        blue: 'linear-gradient(45deg, var(--mantine-color-gray-8), var(--mantine-color-dark-7))',
        purple: 'linear-gradient(45deg, var(--mantine-color-dark-5), var(--mantine-color-dark-8))',
        orange: 'linear-gradient(45deg, var(--mantine-color-gray-7), var(--mantine-color-gray-9))',
        pink: 'linear-gradient(45deg, var(--mantine-color-gray-8), var(--mantine-color-dark-6))',
    };

    const style: CSSProperties = {
        background: gradients[color],
    };

    if (type === 'text') {
        style.WebkitBackgroundClip = 'text';
        style.WebkitTextFillColor = 'transparent';
    }

    return style;
};

export { gradient };
